import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { topics } from "@/mocks/home";

export default function TopicSection() {
  const [featured, ...rest] = topics;

  return (
    <section id="topics" className="w-full bg-background-100">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <SectionHeading
            eyebrow="BLACK-TALK TOPICS"
            title="黑料专题 · 大图卡片流"
            desc="把分散在各处的条目整理成一份可追更的专题目录，封面先看、更新再追，点开就是完整脉络。"
            actionText="查看全部专题"
            actionHref="#topics"
          />
        </Reveal>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-12 md:gap-6">
          <Reveal className="lg:col-span-7" delay={60}>
            <a
              href="#topics"
              className="group block h-full overflow-hidden rounded-lg border border-background-200 bg-background-50 cursor-pointer"
            >
              <div className="relative h-64 w-full overflow-hidden md:h-[380px]">
                <img
                  src={featured.cover}
                  alt={`${featured.title}封面`}
                  title={`31黑料网黑料专题 ${featured.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 ease-soft group-hover:scale-[1.04]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <span className="absolute left-5 top-5 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1.5 text-xs font-label text-background-50 dark:text-foreground-950">
                  <i className="ri-star-smile-line text-sm" />
                  {featured.badge}
                </span>
                <div className="absolute bottom-5 left-5 right-5">
                  <span className="text-xs font-label tracking-wide text-white/70">
                    {featured.category} · {featured.count}
                  </span>
                  <h3 className="mt-2 font-heading text-xl font-bold text-white md:text-2xl">
                    {featured.title}
                  </h3>
                </div>
              </div>
              <div className="flex items-start justify-between gap-4 p-5 md:p-6">
                <p className="text-sm leading-relaxed text-foreground-600">{featured.desc}</p>
                <span className="flex shrink-0 items-center gap-1 text-xs font-label text-foreground-500">
                  <i className="ri-fire-line text-sm text-primary-500" />
                  {featured.heat}
                </span>
              </div>
            </a>
          </Reveal>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-5 lg:grid-cols-1 md:gap-6">
            {rest.map((topic, index) => (
              <Reveal key={topic.id} delay={120 + index * 60}>
                <a
                  href="#topics"
                  className="group flex h-full items-stretch gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3.5 cursor-pointer"
                >
                  <div className="relative h-24 w-28 shrink-0 overflow-hidden rounded-md sm:w-32">
                    <img
                      src={topic.cover}
                      alt={`${topic.title}封面`}
                      title={`31黑料网黑料专题 ${topic.title}`}
                      className="h-full w-full object-cover object-top transition-transform duration-700 ease-soft group-hover:scale-105"
                    />
                  </div>
                  <div className="flex min-w-0 flex-1 flex-col justify-between py-0.5">
                    <div>
                      <div className="flex items-center gap-2">
                        <span className="rounded-md bg-accent-100 px-2 py-0.5 text-[11px] font-label text-accent-900">
                          {topic.category}
                        </span>
                        <span className="text-[11px] font-label text-foreground-500">
                          {topic.badge}
                        </span>
                      </div>
                      <h3 className="mt-2 truncate font-heading text-base font-bold text-foreground-950 transition-colors duration-300 group-hover:text-primary-700">
                        {topic.title}
                      </h3>
                      <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                        {topic.desc}
                      </p>
                    </div>
                    <div className="mt-2 flex items-center gap-4 text-[11px] font-label text-foreground-500">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-stack-line text-sm" />
                        {topic.count}
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-fire-line text-sm text-primary-500" />
                        {topic.heat}
                      </span>
                    </div>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}